<chartjs-container [config]="chartConfig()" [heightPx]="100">
</chartjs-container>
